import React from "react"

import "./ClientCarousel.scss"

import bmw from "../images/clients/bmw.png"
import simi from "../images/clients/simi.png"
import ac from "../images/clients/ac.png"
import bimbo from "../images/clients/bimbo.png"
import televisa from "../images/clients/televisa.png"
import hsbc from "../images/clients/hsbc.png"

import totalplay from "../images/clients/totalplay.png"
import pfizer from "../images/clients/pfizer.png"
import herdez from "../images/clients/herdez.png"
import metlife from "../images/clients/metlife.png"
import rotoplas from "../images/clients/rotoplas.png"
import pg from "../images/clients/pg.png"
import zignia from "../images/clients/zignia.png"

import heb from "../images/clients/heb.png"
import ferrero from "../images/clients/ferrero.png"
import minera from "../images/clients/minera.png"
import sanofi from "../images/clients/sanofi.png"
import mondelez from "../images/clients/mondelez.png"
import roche from "../images/clients/roche.png"

import delarosa from "../images/clients/delarosa.png"
import deutsche from "../images/clients/deutsche.png"

class ClientCarousel extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      steps: 3,
      counter: 0,
      interval: undefined
    }

    this.handleOnClick = this.handleOnClick.bind(this)
  }
  componentDidMount() {
    let interval = this.startInterval()
    this.setState({ interval: interval })
  }
  componentWillUnmount() {
    clearInterval(this.state.interval)
  }
  startInterval() {
    return setInterval(() => {
      let { steps, counter } = this.state

      if (counter < steps) {
        this.setState({ counter: counter + 1 })
      }
      else {
        this.setState({ counter: 0 })
      }
    }, 3000)
  }
  handleOnClick(i) {
    this.setState({ counter: i })
    clearInterval(this.state.interval)

    let interval = this.startInterval()
    this.setState({ interval: interval })
  }
  render() {
    let { counter } = this.state
    let stepsArray = [0, 1, 2, 3]
    return (
      <div className="carrousel">
        <div className="list mobile">
          <div className="step" style={{ marginLeft: `${counter * '-100'}%` }}>
            <img src={hsbc} alt="hsbc" />
            <img src={bimbo} alt="bimbo" />
            <img src={ac} alt="arca continental" />
          </div>
          <div className="step">
            <img src={simi} alt="similares" />
            <img src={bmw} alt="bmw" />
            <img src={televisa} alt="televisa" />
          </div>
          <div className="step">
            <img src={metlife} alt="metlife" />
            <img src={pg} alt="P&G" />
            <img src={totalplay} alt="totalplay" />
            <img src={pfizer} alt="pfizer" />
          </div>
          <div className="step">
            <img src={heb} alt="heb" />
            <img src={rotoplas} alt="rotoplas" />
            <img src={ferrero} alt="ferrero rocher" />
            <img src={minera} alt="minera mexico" />
          </div>
          <div className="step">
            <img src={sanofi} alt="sanofi" />
            <img src={roche} alt="roche" />
            <img src={delarosa} alt="delarosa" />
            <img src={deutsche} alt="deutsche" />
          </div>
          <div className="step">
            <img src={zignia} alt="zignia" />
            <img src={herdez} alt="herdez" />
            <img src={mondelez} alt="mondelez" />
          </div>
        </div>
        <div className="list desktop">
          <div className="step" style={{ marginLeft: `${counter * '-100'}%` }}>
            <img src={hsbc} alt="hsbc" />
            <img src={bimbo} alt="bimbo" />
            <img src={ac} alt="arca continental" />
            <img src={simi} alt="similares" />
          </div>
          <div className="step">
            <img src={bmw} alt="bmw" />
            <img src={televisa} alt="televisa" />
            <img src={metlife} alt="metlife" />
            <img src={pg} alt="P&G" />
            <img src={totalplay} alt="totalplay" />
            <img src={pfizer} alt="pfizer" />
          </div>
          <div className="step">
            <img src={heb} alt="heb" />
            <img src={rotoplas} alt="rotoplas" />
            <img src={ferrero} alt="ferrero rocher" />
            <img src={minera} alt="minera mexico" />
            <img src={sanofi} alt="sanofi" />
            <img src={roche} alt="roche" />
          </div>
          <div className="step">
            <img src={delarosa} alt="delarosa" />
            <img src={deutsche} alt="deutsche" />
            <img src={zignia} alt="zignia" />
            <img src={herdez} alt="herdez" />
            <img src={mondelez} alt="mondelez" />
          </div>
        </div>
        <div className="dots">
          {
            stepsArray.map((el, i) => (
              <button
                key={i}
                className={['dot', (i === counter ? ' active' : null)].join('')}
                onClick={e => this.handleOnClick(i)}
                aria-label="pages"
              ></button>
            ))
          }
        </div>
      </div>
    )
  }
}

export default ClientCarousel